import React ,{ Component }from "react";
import { FiLayers , FiUsers , FiMonitor, FiPhoneOutgoing, FiGift, FiFigma } from "react-icons/fi";

class ServiceThree extends Component{
    render(){        
        return(
            <React.Fragment>
                <div className="row">
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="0">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiMonitor />
                            </div>
                            <div className="content">
                                <h3 className="title">Desarrollo web</h3>
                                <p>Realización de páginas web a medida con los frameworks Laravel (PHP) y React (Javascript/Typescript).</p>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="1">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiPhoneOutgoing />
                            </div>
                            <div className="content">
                                <h3 className="title">Desarrollo móvil</h3>
                                <p>Realización de aplicaciones móviles tanto multiplataforma, con Flutter y React Native, como nativas con Android (Kotlin).</p>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="2">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiGift />
                            </div>
                            <div className="content">
                                <h3 className="title">Garantía</h3>
                                <p>Nos comprometemos con que el trabajo desarrollado salga adelante, si algo desarrollado no funciona, lo arreglaremos gratis.</p>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="3">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiLayers />
                            </div>
                            <div className="content">
                                <h3 className="title">Backend e Infraestructuras</h3>
                                <p>Gestión y desarrollo de bases de datos y mantenimiento de Infraestructuras (IaaS, PaaS...). Nosotros nos encargamos de encontrar y montar los servidores que más se ajusten a tus necesidades.</p>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="4">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiUsers />
                            </div>
                            <div className="content">
                                <h3 className="title">Cercanía y transparencia</h3>
                                <p>Continuamente informamos a nuestros clientes del estado del desarrollo, envíando actualizaciones a diario y aportando prototipos continuos para que estén al corriente del trabajo que se realiza.</p>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-left`} key="4">
                        <div className="service service__style--2">
                            <div className="icon">
                                <FiFigma />
                            </div>
                            <div className="content">
                                <h3 className="title">Accesibilidad y usabilidad</h3>
                                <p>¿No tienes muy claro como conseguir que la aplicación sea lo más intuitiva posible? Plasmaremos toda nuestra experiencia en aconsejarte para que la aplicación sea lo más accesible posible.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
